/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Table, Space, Modal } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";

import DetailedFeedbackModal from "./DetailedFeedbackModal";
import { showErrorNotification, showSuccessNotification } from "../../../utils/notification";
import {
  LectureFeedbackQuestionTable,
  LectureFeedbackTableBasicColumns
} from "../../common-utils/LectureFeedback";

const CourseLectureFeedbackModal = ({
  isModalOpen = false,
  setIsModalOpen = () => {},
  currentCourseId = "",
  ROOT_URL = ""
}) => {
  const [lecturesFeedbackColumns, setLecturesFeedbackColumns] = useState([]);
  const [courseLectureFeedbackObj, setCourseLectureFeedbackObj] = useState({});
  const [detailedResponses, setDetailedResponses] = useState([]);
  const [isViewDetailedFeedbackModal, setIsViewDetailedFeedbackModal] = useState(false);

  const fetchCourseLecturesFeedback = () => {
    axios
      .get(`${ROOT_URL}/admin/courses/lecture-feedback/list`, {
        params: {
          filter: {
            courseId: currentCourseId
          }
        }
      })
      .then(({ data }) => {
        setCourseLectureFeedbackObj(data);
        showSuccessNotification("Lectures Feedback fetched successfully");
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const fetchDetailedCourseLectureFeedback = (values) => {
    const { subsectionId = "" } = values;
    axios
      .get(`${ROOT_URL}/admin/courses/lecture-feedback/detailed-list`, {
        params: {
          filter: {
            lectureId: subsectionId,
            courseId: currentCourseId
          }
        }
      })
      .then((res) => {
        const { responsesData } = res.data;
        setDetailedResponses(responsesData);
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const componentSpecificColumns = [
    {
      title: "Educator",
      key: "educatorName",
      dataIndex: "educatorName",
      sorter: (a, b) => {
        if (typeof a.name === "string" && typeof b.name === "string") {
          return a.name?.localeCompare(b.name) | 0;
        }
        // Fallback comparison if not string (handle the case if one or both values are not strings)
        return 0;
      }
    },
    {
      title: "Actions",
      key: "action",
      width: 200,

      render: (row) => (
        <div
          id="lecture_feedback_row_actions"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around"
          }}
        >
          <Space wrap>
            <>
              <Button
                type="primary"
                onClick={() => {
                  fetchDetailedCourseLectureFeedback({ subsectionId: row.lectureId });
                  setIsViewDetailedFeedbackModal(true);
                }}
              >
                View Details
              </Button>
            </>
          </Space>
        </div>
      )
    }
  ];

  useEffect(() => {
    setLecturesFeedbackColumns(LectureFeedbackTableBasicColumns().concat(componentSpecificColumns));
    fetchCourseLecturesFeedback();
  }, [currentCourseId]);

  return (
    <Modal
      title="Lecture's Feedback"
      centered
      width={2000}
      open={isModalOpen}
      footer={[]}
      onOk={() => {
        setIsModalOpen(false);
      }}
      onCancel={() => {
        setIsModalOpen(false);
      }}
    >
      <LectureFeedbackQuestionTable questions={courseLectureFeedbackObj.questions} />
      <Table
        columns={lecturesFeedbackColumns}
        dataSource={courseLectureFeedbackObj.lecturesFeedbacks}
        bordered
        pagination={false}
        scroll={{ x: "max-content" }}
      />
      {isViewDetailedFeedbackModal === true && (
        <DetailedFeedbackModal
          isModalOpen={isViewDetailedFeedbackModal}
          setIsModalOpen={setIsViewDetailedFeedbackModal}
          responsesData={detailedResponses || []}
          questionsData={courseLectureFeedbackObj.questions}
        />
      )}
    </Modal>
  );
};

export default CourseLectureFeedbackModal;
